import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AccessibilityWrapper } from "@/components/accessibility";
import { useTestId } from "@/hooks";
import { Box } from "@gemini/core";
import { useHardFacts } from "@/contexts/classified";
export const PriceValue = () => {
    var _a;
    const testId = useTestId("Sections.Hardfacts.Price.Value");
    const { formatted, ariaLabel } = ((_a = useHardFacts()) === null || _a === void 0 ? void 0 : _a.price) || {};
    return (_jsxs(_Fragment, { children: [_jsx(AccessibilityWrapper, { children: ariaLabel }), _jsx(Box, { as: "span", testId: testId, "aria-hidden": true, typography: "typography.headline.24.bold", children: formatted })] }));
};
